(() => {
  // app/scripts/common/define.js
  Object.assign(NodeList.prototype, {
    removeClass: function() {
      for (const item of this) {
        item.classList.remove(...arguments);
      }
    },
    addClass: function() {
      for (const item of this) {
        item.classList.add(...arguments);
      }
    },
    addEvents: function(...args) {
      for (const item of this) {
        item.addEvent(...args);
      }
    },
    removeEvents: function(...args) {
      for (const item of this) {
        item.removeEvent(...args);
      }
    }
  });
  Object.assign(HTMLCollection.prototype, {
    removeClass: function() {
      for (const item of this) {
        item.classList.remove(...arguments);
      }
    },
    addClass: function() {
      for (const item of this) {
        item.classList.add(...arguments);
      }
    },
    addEvents: function(...args) {
      for (const item of this) {
        item.addEventListener(...args);
      }
    },
    removeEvents: function(...args) {
      for (const item of this) {
        item.removeEventListener(...args);
      }
    },
    forEach: Array.prototype.forEach
  });
  Object.assign(HTMLElement.prototype, {
    removeClass: function(...args) {
      this.classList.remove(...args);
      return this;
    },
    addClass: function(...args) {
      this.classList.add(...args);
      return this;
    },
    hasClass: function(className) {
      return this.classList.contains(className);
    },
    css(key, value) {
      this.style[key] = value;
    }
  });
  Object.assign(Number.prototype, {
    toCurrency: moneyFormat
  });
  Object.assign(String.prototype, {
    toCurrency: moneyFormat,
    convertToSlug
  });
  function convertToSlug() {
    let str = this;
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
    str = str.replace(/\u02C6|\u0306|\u031B/g, "");
    return str.toLowerCase().replace(/-/g, " ").trim().replace(/[\(\)\[\]'"]/g, "").replace(/[^\w]+/g, "-");
  }
  var moneyFormatString = theme.currency.code ? theme.currency.money_with_currency_format : theme.currency.format;
  function moneyFormat(format) {
    let cents = this;
    if (cents instanceof String) {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormatString;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  (function() {
    let nativeFetch = window.fetch;
    window.fetch = function(...agrs) {
      let dataType = !!agrs[1] ? agrs[1].dataType : "";
      return nativeFetch(...agrs).then(async (res) => {
        if (!res.ok && res.type === "basic") {
          throw await res.json();
        }
        switch (dataType) {
          case "json": {
            return res.json();
          }
          case "text": {
            return res.text();
          }
          default:
            return res;
        }
      });
    };
  })();

  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    }
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute.");
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
      throw new TypeError("Theme Sections: The properties object provided is not a valid");
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  function register(type, properties) {
    if (typeof type !== "string") {
      throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
    }
    function TypedSection(container) {
      Section.call(this, container, properties);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function(type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function(container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function(instance) {
      var index = instances.map(function(e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function(container) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.container === container;
        }));
      });
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);
      types.forEach(function(type) {
        filteredInstances = filteredInstances.concat(instances.filter(function(instance) {
          return instance.type === type;
        }));
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function(TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function(type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id + '"]');
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function(event) {
      var id = event.detail.sectionId;
      var container = event.target.querySelector("[" + SECTION_ID_ATTR2 + '="' + id + '"]');
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function(event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // app/scripts/common/model/cart.js
  var Cart = class {
    constructor() {
      this.settings = { ...theme.settings.cart };
      this.cart = {};
      this.get();
      document.addEvent("cart-change", ({ detail }) => {
        const { sections } = detail;
        const cartItemCount = document.getElementsByClassName("js-cart-item-count");
        [...cartItemCount].forEach((item) => {
          const parsedHTML = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
          item.innerHTML = parsedHTML.querySelector(".shopify-section").innerHTML;
        });
      });
      document.addEvent("cart-add", ({ detail }) => {
        if (theme.settings.cart.type == "page" || window.theme.pageType == "cart")
          return;
        const cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.updateContent(detail);
        if (!detail.isError) {
          cartDrawer.open();
        }
      });
    }
    add(form) {
      const formData = new FormData(form);
      formData.append("sections", this.getSectionsToRender().join(","));
      return fetch(theme.routes.cartAdd, {
        method: "post",
        headers: new Headers({ "X-Requested-With": "XMLHttpRequest" }),
        body: formData,
        dataType: "json"
      }).then((res) => {
        if (window.theme?.settings?.cart?.type == "page") {
          window.location.href = window.Shopify.routes.root + "cart";
        } else {
          window.Popups.closeAll();
          document.dispatchEvent(new CustomEvent("cart-add", { detail: res }));
          document.dispatchEvent(new CustomEvent("cart-change", { detail: res }));
          this.get();
          return res;
        }
      });
    }
    get() {
      return fetch(theme.routes.cartGet, { dataType: "json" }).then((res) => Object.assign(this.cart, res));
    }
    clear() {
      return fetch(theme.routes.cartClear, { dataType: "json" }).then((res) => {
        this.get();
        return res;
      });
    }
    change(line, quantity) {
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender(),
        sections_url: window.location.pathname
      });
      return fetch(theme.routes.cartChange, {
        method: "POST",
        headers: new Headers({ "Content-Type": "application/json" }),
        dataType: "json",
        body
      }).then((res) => {
        document.dispatchEvent(new CustomEvent("cart-change", { detail: res }));
        this.get();
        return res;
      });
    }
    getSectionsToRender() {
      if (theme.template == "cart") {
        const cartContainer = document.querySelector("cart-container");
        const sectionID = cartContainer.dataset.id;
        return ["cart-icon-bubble", "cart-live-region-text", sectionID];
      } else {
        return ["cart-icon-bubble", "cart-live-region-text", "ajax-cart"];
      }
    }
  };

  // app/scripts/common/model/quantity-input.js
  var QuantityInput = class extends HTMLElement {
    constructor() {
      super();
      this.minusButton = this.querySelector(".quantity-input-minus");
      this.plusButton = this.querySelector(".quantity-input-plus");
      this.input = this.querySelector("input[type='number']");
      this.minusButton.addEvent("click", this.onMinusButtonClick.bind(this));
      this.plusButton.addEvent("click", this.onPlusButtonClick.bind(this));
      this.input.addEventListener("change", this.onInputChange.bind(this));
    }
    connectedCallback() {
      this.validateQtyRules();
    }
    onInputChange(e) {
      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = +this.input.value;
      if (this.input.min) {
        this.minusButton.setAttribute("aria-disabled", value <= parseInt(this.input.min));
      }
      if (this.input.max) {
        this.plusButton.setAttribute("aria-disabled", value >= parseInt(this.input.max));
      }
    }
    onMinusButtonClick(e) {
      let min = this.input.min ? +this.input.min : 1;
      let { value } = this.input;
      --value;
      if (value >= min) {
        this.input.value = value;
        this.input.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        this.input.value = min;
      }
    }
    onPlusButtonClick(e) {
      let max = this.input.max ? +this.input.max : null;
      let { value } = this.input;
      ++value;
      if (max) {
        if (value <= max) {
          this.input.value = value;
          this.input.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          this.input.value = max;
        }
      } else {
        this.input.value = value;
        this.input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  };

  // app/scripts/common/model/popups.js
  var Popups2 = class {
    constructor() {
      this.list = {};
    }
    open(id) {
      this.list[id] && this.list[id].open();
    }
    close(id) {
      this.list[id] && this.list[id].close();
    }
    closeAll() {
      Object.keys(this.list).forEach((key) => this.list[key].close());
    }
    push(name, element) {
      this.list[name] = element;
    }
    get(name) {
      return this.list[name];
    }
  };

  // app/scripts/common/model/popup-component.js
  var PopupComponent = class extends HTMLElement {
    constructor() {
      super();
      this.getElementsByClassName("js-popup-close").addEvents("click", this.close.bind(this));
    }
    close() {
      this.removeClass("is-open");
      AT.enableScroll();
    }
    open() {
      this.addClass("is-open");
      AT.disableScroll();
    }
  };

  // app/scripts/common/model/popup-message.js
  var PopupMessage = class extends PopupComponent {
    constructor() {
      super();
      this.focusTrap = window.focusTrap.createFocusTrap(this, {
        escapeDeactivates: false
      });
    }
    open(message) {
      this.addClass("is-open");
      this.querySelector(".js-message").innerHTML = message;
      AT.disableScroll();
      setTimeout(() => {
        this.focusTrap.activate();
      }, 600);
    }
    close() {
      this.removeClass("is-open");
      AT.enableScroll();
      this.focusTrap.deactivate();
    }
  };

  // app/scripts/common/model/tabs.js
  var CustomTabs = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.tabDir = this.dataset.dir || this.getAttribute("aria-orientation") || "horizontal";
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.tabList = this.querySelector('[role="tablist"]');
      this.tabs.forEach((tab) => tab.addEventListener("click", this.changeTabs.bind(this)));
      let tabFocus = 0;
      this.tabList.addEventListener("keydown", (e) => {
        const key = e.key.toUpperCase();
        if (this.tabDir == "horizontal") {
          if (key === "ARROWRIGHT" || key === "ARROWLEFT") {
            this.tabs[tabFocus].setAttribute("tabindex", -1);
            if (key === "ARROWRIGHT") {
              tabFocus++;
              if (tabFocus >= this.tabs.length) {
                tabFocus = 0;
              }
            } else if (key === "ARROWLEFT") {
              tabFocus--;
              if (tabFocus < 0) {
                tabFocus = this.tabs.length - 1;
              }
            }
            this.tabs[tabFocus].setAttribute("tabindex", 0);
            this.tabs[tabFocus].focus();
          }
        } else {
          if (key === "ARROWDOWN" || key === "ARROWUP") {
            e.preventDefault();
            this.tabs[tabFocus].setAttribute("tabindex", -1);
            if (key === "ARROWDOWN") {
              tabFocus++;
              if (tabFocus >= this.tabs.length) {
                tabFocus = 0;
              }
            } else if (key === "ARROWUP") {
              tabFocus--;
              if (tabFocus < 0) {
                tabFocus = this.tabs.length - 1;
              }
            }
            this.tabs[tabFocus].setAttribute("tabindex", 0);
            this.tabs[tabFocus].focus();
          }
        }
      });
    }
    changeTabs(e) {
      const target = e.target;
      this.tabList.querySelectorAll('[aria-selected="true"]').forEach((t) => {
        t.setAttribute("aria-selected", false);
        t.tabIndex = -1;
        t.classList.remove("active");
      });
      target.setAttribute("aria-selected", true);
      target.tabIndex = 0;
      target.classList.add("active");
      this.querySelectorAll('[role="tabpanel"]').forEach((p) => {
        p.setAttribute("hidden", true);
        p.classList.remove("active");
      });
      let selectedPanel = this.querySelector(`#${target.getAttribute("aria-controls")}`);
      if (!!selectedPanel.querySelector("template")) {
        let template = selectedPanel.querySelector("template");
        selectedPanel.appendChild(template.content);
        template.remove();
      }
      selectedPanel.removeAttribute("hidden");
      selectedPanel.classList.add("active");
    }
  };

  // app/scripts/common/model/accordion.js
  var Accordion = class {
    constructor(el, options = {}) {
      if (!el)
        return;
      this.el = el;
      this.options = options;
      this.summary = el.querySelector("summary");
      this.panel = this.summary.nextElementSibling;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener("click", (e) => this.onClick(e));
      this.setAccordionAccessibility();
      this.el.classList.add("accordion-initialized");
    }
    setAccordionAccessibility() {
      this.summary.setAttribute("aria-expanded", this.el.open);
      if (this.panel.getAttribute("id")) {
        this.summary.setAttribute("aria-controls", this.panel.id);
      }
      this.el.addEventListener("keyup", (e) => {
        if (!e.code || e.code.toUpperCase() !== "ESCAPE" || !this.el.open)
          return;
        e.stopPropagation();
        this.summary.dispatchEvent(new Event("click"));
      });
    }
    onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      const { onPreOpen } = this.options;
      this.el.style.overflow = "hidden";
      if (this.isClosing || !this.el.open) {
        if (onPreOpen && typeof onPreOpen == "function")
          onPreOpen();
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      let duration = 500;
      if (this.el.offsetHeight < 150) {
        duration = 200;
      } else if (this.el.offsetHeight < 300) {
        duration = 250;
      } else if (this.el.offsetHeight < 450) {
        duration = 300;
      } else if (this.el.offsetHeight < 600) {
        duration = 350;
      } else if (this.el.offsetHeight < 750) {
        duration = 400;
      } else if (this.el.offsetHeight < 900) {
        duration = 450;
      }
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }
    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }
    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.el.scrollHeight}px`;
      let duration = 500;
      if (this.el.scrollHeight < 150) {
        duration = 200;
      } else if (this.el.scrollHeight < 300) {
        duration = 250;
      } else if (this.el.scrollHeight < 450) {
        duration = 300;
      } else if (this.el.scrollHeight < 600) {
        duration = 350;
      } else if (this.el.scrollHeight < 750) {
        duration = 400;
      } else if (this.el.scrollHeight < 900) {
        duration = 450;
      }
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration,
        easing: "ease-out"
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }
    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = "";
      this.summary.focus();
      this.summary.setAttribute("aria-expanded", open);
    }
  };
  var CustomAccordion = class extends HTMLElement {
    connectedCallback() {
      this.options = {};
      const { closeOtherAccordions, container } = this.dataset;
      if (closeOtherAccordions == "true") {
        this.closeOtherAccordions(container);
      }
      this.accordion = new Accordion(this.querySelector("details"), this.options);
    }
    closeOtherAccordions(container) {
      this.options = Object.assign(this.options, {
        onPreOpen: function() {
          if (!container || !document.querySelector(container))
            return;
          const containerElement = document.querySelector(container);
          containerElement.querySelectorAll("c-accordion:not([data-prevent-close]) details[open] summary").forEach((summary) => summary.click());
        }
      });
    }
  };

  // app/scripts/common/model/countdown-timer.js
  var CustomCountdown = class extends HTMLElement {
    constructor() {
      super();
      try {
        let time = this.dataset.expired.split(",");
        if (time.length > 3) {
          this.deadline = new Date(time[0], time[1], time[2], time[3], time[4] || 0, time[5] || 0).getTime();
        } else {
          this.deadline = new Date(time[0], time[1], time[2]).getTime();
        }
      } catch (e) {
        console.log(e);
        return;
      }
      this.days = this.querySelector(".js-days");
      this.hours = this.querySelector(".js-hours");
      this.minutes = this.querySelector(".js-minutes");
      this.seconds = this.querySelector(".js-seconds");
      let currentTime = new Date().getTime();
      if (this.deadline - currentTime <= 0) {
        this.closest(".js-countdown-wrapper")?.classList.add("hide");
        return;
      }
      this.observer = new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting)
          return;
        observer.unobserve(this);
        this.isIntersecting = true;
        requestAnimationFrame(this.countDown.bind(this));
      }, { rootMargin: "400px 0px 400px 0px" });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (!this.isIntersecting)
        this.observer?.unobserve(this);
    }
    pad(value) {
      return (Math.floor(value) < 10 ? "0" : "") + Math.floor(value);
    }
    countDown() {
      const currentTime = new Date().getTime();
      const remain = this.deadline - currentTime;
      const days = this.pad(remain / (24 * 60 * 60 * 1e3));
      const hours = this.pad(remain / (60 * 60 * 1e3) % 24);
      const minutes = this.pad(remain / (60 * 1e3) % 60);
      const seconds = this.pad(remain / 1e3 % 60);
      this.days.innerHTML = days;
      this.days.setAttribute("data-count", days);
      this.hours.innerHTML = hours;
      this.hours.setAttribute("data-count", hours);
      this.minutes.innerHTML = minutes;
      this.minutes.setAttribute("data-count", minutes);
      this.seconds.innerHTML = seconds;
      this.seconds.setAttribute("data-count", seconds);
      if (remain >= 1e3) {
        requestAnimationFrame(this.countDown.bind(this));
      } else {
        this.closest(".js-countdown-wrapper")?.classList.add("hide");
      }
      if (days == "00") {
        this.days.closest(".day-container").classList.add("hide");
        if (this.days.closest(".day-container").nextElementSibling.classList.contains("colon")) {
          this.days.closest(".day-container").nextElementSibling.classList.add("hide");
        }
      }
    }
  };

  // app/scripts/common/model/wishlist.js
  var CustomWishlist = class {
    constructor() {
      if (!window.theme.settings.wishlist.enable)
        return;
      this.wishlist = localStorage.getItem("wishlist") ? localStorage.getItem("wishlist").split("|") : [];
    }
    add(product) {
      let wishlist = localStorage.getItem("wishlist");
      let currentValue = wishlist ? wishlist.split("|") : [];
      let newValue = [product.handle, ...currentValue];
      newValue = [...new Set(newValue)];
      if (newValue.length > 10)
        newValue.length = 10;
      this.wishlist = newValue;
      localStorage.setItem("wishlist", newValue.join("|"));
      document.dispatchEvent(new CustomEvent("wishlist-add"));
      document.dispatchEvent(new CustomEvent("wishlist-change"));
    }
    remove(product) {
      let wishlist = localStorage.getItem("wishlist");
      let currentValue = wishlist.split("|");
      let newValue = currentValue.filter((handle) => handle != product.handle);
      this.wishlist = newValue;
      if (newValue.length == 0) {
        localStorage.removeItem("wishlist");
      } else {
        localStorage.setItem("wishlist", newValue.join("|"));
      }
      document.dispatchEvent(new CustomEvent("wishlist-remove"));
      document.dispatchEvent(new CustomEvent("wishlist-change"));
    }
    showPopup(product, addItem = true) {
      const activeClass = addItem ? "is-added" : "is-deleted";
      const wishlistPopupContainer = document.querySelector("#wishlist-popup-container");
      const wishlistPopupTemplate = wishlistPopupContainer.querySelector("template.popup-wishlist-template");
      const clonePopup = wishlistPopupTemplate.content.cloneNode(true).children[0];
      const clonePopupPosition = wishlistPopupContainer.dataset.position;
      if (product.image) {
        clonePopup.querySelector(".js-wishlist-img").dataset.srcset = product.image;
        clonePopup.querySelector(".js-wishlist-img").dataset.aspectratio = product.imageRatio;
        clonePopup.querySelector(".js-wishlist-img-wrapper").style.paddingTop = product.imagePadding;
        clonePopup.querySelector(".js-wishlist-svg-wrapper").remove();
      } else {
        clonePopup.querySelector(".js-wishlist-svg-wrapper").style.paddingTop = product.imagePadding;
        clonePopup.querySelector(".js-wishlist-img-wrapper").remove();
      }
      clonePopup.querySelector(".js-wishlist-title").innerHTML = product.title;
      clonePopup.querySelector(".js-wishlist-message").classList.remove("is-added", "is-deleted");
      clonePopup.querySelector(".js-wishlist-message").classList.add(activeClass);
      let position = "";
      let prevPopupHeight = 0;
      let array = document.querySelectorAll(".popup-wishlist.is-open");
      if (clonePopupPosition == "top-left" || clonePopupPosition == "top-right") {
        position = "beforeend";
      } else {
        position = "afterbegin";
      }
      if (array.length > 0) {
        prevPopupHeight = [...array].reduce((accumulator, currentValue) => {
          return accumulator + currentValue.querySelector(".popup-component_box").offsetHeight + 20;
        }, 0);
      }
      clonePopup.querySelector(".popup-component_box").style.setProperty("--prev-popup-height", prevPopupHeight + "px");
      clonePopup.querySelector(".popup-component_box").style.setProperty("--prev-popup-height-no-px", prevPopupHeight);
      wishlistPopupContainer.insertAdjacentElement(position, clonePopup);
      setTimeout(() => {
        clonePopup.open();
      }, 100);
      setTimeout(() => {
        const clonePopupHeight = clonePopup.querySelector(".popup-component_box").offsetHeight;
        clonePopup.close();
        clonePopup.remove();
        let array2 = document.querySelectorAll(".popup-wishlist.is-open");
        array2.forEach((popup) => {
          const box = popup.querySelector(".popup-component_box");
          const nopx = box.style.getPropertyValue("--prev-popup-height-no-px");
          box.style.setProperty("--prev-popup-height", parseInt(nopx) - clonePopupHeight - 20 + "px");
          box.style.setProperty("--prev-popup-height-no-px", parseInt(nopx) - clonePopupHeight - 20);
        });
      }, 2200);
    }
  };

  // app/scripts/common/function/detectVisible.js
  var detectVisible = ({ element, rootMargin, callback, threshold = 0 }) => {
    if (typeof IntersectionObserver === "undefined") {
      callback();
      return;
    }
    let observer = new IntersectionObserver((entries, observer2) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback();
          observer2.unobserve(element);
        }
      });
    }, { rootMargin });
    observer.observe(element);
  };

  // app/scripts/common/function/disableScroll.js
  function disableScroll(hasPadding = true) {
    let paddingRight = (hasPadding ? window.innerWidth - document.documentElement.offsetWidth : 0) + "px";
    document.documentElement.style.paddingRight = paddingRight;
    document.documentElement.addClass("overflow-hidden");
  }

  // app/scripts/common/function/enableScroll.js
  function enableScroll() {
    document.documentElement.style.paddingRight = "";
    document.documentElement.removeClass("overflow-hidden");
  }

  // app/scripts/common/function/debounce.js
  var debounce = (func, wait) => {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // app/scripts/common/function/loadScript.js
  var loadScript = (url, cb) => {
    let script = document.createElement("script");
    script.src = url;
    !!cb && (script.onload = cb);
    script.onError = () => {
      console.warn("Has an error when loading script:", url);
    };
    document.body.append(script);
  };

  // app/scripts/common/function/getParameterByName.js
  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
      return null;
    if (!results[2])
      return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // app/scripts/common/function/scrollTo.js
  function scrollTo(element, duration, minus = 0) {
    return new Promise((resolve, reject) => {
      var startingY = window.scrollY;
      var elementY = getElementY(element) - minus;
      var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
      var diff = targetY - startingY;
      var easing = function(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      };
      var start;
      if (!diff)
        return resolve(1);
      window.requestAnimationFrame(function step(timestamp) {
        if (!start)
          start = timestamp;
        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        percent = easing(percent);
        window.scrollTo(0, startingY + diff * percent);
        if (time < duration) {
          window.requestAnimationFrame(step);
        } else {
          resolve(1);
        }
      });
    });
  }
  function getElementY(query) {
    return typeof query == "number" ? query : window.pageYOffset + query.getBoundingClientRect().top;
  }

  // app/scripts/common/function/backToTop.js
  function initBackToTop() {
    let backToTopButton = document.getElementById("back-to-top");
    backToTopButton.addEvent("click", () => {
      AT.scrollTo(0, 1e3);
    });
    window.addEvent("scroll", () => {
      if (window.scrollY > window.innerHeight * 1.5) {
        backToTopButton.addClass("show");
      } else {
        backToTopButton.removeClass("show");
      }
    });
  }

  // app/scripts/common/function/cookie.js
  var cookie = {
    get: function(key) {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? JSON.parse(keyValue[2]) : null;
    },
    set: function(key, value, expiry) {
      var expires = new Date();
      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
      document.cookie = key + "=" + JSON.stringify(value) + ";expires=" + expires.toUTCString() + ";path=/";
    },
    delete: function(key) {
      var keyValue = this.get(key);
      this.set(key, keyValue, "-1");
    }
  };

  // app/scripts/common/function/loadPopupMessage.js
  function loadPopupMessage() {
    return new Promise((resolve, reject) => {
      if (typeof window.PopupMessage != "undefined") {
        resolve(1);
        return;
      }
      let template = document.getElementById("popup-container");
      let popupMessage = template.content.querySelector("popup-message");
      if (popupMessage) {
        template.insertAdjacentElement("beforebegin", popupMessage);
        customElements.define("popup-message", PopupMessage);
        window.PopupMessage = popupMessage;
        Popups.push("popup-message", window.PopupMessage);
        return resolve(1);
      }
      return reject(0);
    });
  }

  // app/scripts/common/function/loadPopupQuickView.js
  function loadPopupQuickView() {
    return new Promise((resolve, reject) => {
      if (typeof window.PopupQuickView != "undefined") {
        return resolve(1);
      }
      AT.loadScript(theme.assets.popupQuickView, () => {
        resolve(1);
      });
    });
  }

  // app/scripts/common/function/formatPhoneLink.js
  function formatPhoneLink() {
    function parsePhoneNumberAndGetURI(phoneNumber) {
      const pn = window.AP.parsePhoneNumber(phoneNumber);
      return pn.valid ? pn.number.rfc3966 : null;
    }
    const links = document.querySelectorAll('a[href^="tel:"]');
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        if (link.getAttribute("data-valid"))
          return;
        e.preventDefault();
        const phoneNumber = link.href.split("tel:")[1].trim();
        if (!window.AP) {
          if (link.getAttribute("data-disabled") !== "true") {
            link.setAttribute("data-disabled", true);
            AT.loadScript(theme.assets.apLib, () => {
              const uri = parsePhoneNumberAndGetURI(phoneNumber);
              if (uri)
                link.href = uri;
              link.setAttribute("data-valid", !!uri);
              link.removeAttribute("data-disabled");
              link.click();
            });
          }
        } else {
          if (link.getAttribute("data-disabled") !== "true") {
            link.setAttribute("data-disabled", true);
            const uri = parsePhoneNumberAndGetURI(phoneNumber);
            if (uri)
              link.href = uri;
            link.setAttribute("data-valid", !!uri);
            link.removeAttribute("data-disabled");
            link.click();
          }
        }
      });
    });
  }

  // app/scripts/common.js
  Object.assign(window, {
    load,
    register,
    Cart: new Cart(),
    Wishlist: new CustomWishlist(),
    AT: {
      searchLoaded: false,
      detectVisible,
      disableScroll,
      enableScroll,
      debounce,
      loadScript,
      getParameterByName,
      scrollTo,
      cookie,
      loadPopupMessage,
      loadPopupQuickView,
      productsViewedQuickly: {}
    }
  });
  window.Popups = new Popups2();
  window.PopupComponent = PopupComponent;
  customElements.define("quantity-input", QuantityInput);
  customElements.define("popup-component", PopupComponent);
  customElements.define("c-tabs", CustomTabs);
  customElements.define("c-accordion", CustomAccordion);
  customElements.define("c-countdown", CustomCountdown);
  if (window.theme.pageType != "product" && document.querySelector(".section-featured-product")) {
    if (AT.getParameterByName("contact_posted") || AT.getParameterByName("form_type") == "contact") {
      window.addEventListener("load", () => {
        document.querySelector(".js-product-page-lazyload")?.loadAssets();
      });
    }
  }
  initBackToTop();
  formatPhoneLink();
  console.log("global.js loaded");
})();
